<div class="network-status-container">
  <app-dev-function-code-picker></app-dev-function-code-picker>
  <app-network-status-indicator></app-network-status-indicator>
</div>

<router-outlet></router-outlet>
